import "../tool.js";
import "../../singleton/form_builder/index.js";
import "../modals/form_editor.js";
import "../helpers.js";
import "./form-editor-tool.js";

/**
 * Load lifecycle:
 *  tool.setState - used by tools with more complicated state requirements.
 *                   Most tools just pass the component context to their
 *                   templates, so that's the default
 *  tool.render - by default updates the tool element with markup generated
 *                 by tool template, overrid for react apps
 *  tool.bind - bind events to the tool or component here
 *  tool.unbind - unbind any events
 *
 * Update lifecycle
 *  tool.setState
 *  tool.update
 *  tool.rendered (if the component was rendered)
 *
 * General Notes
 *  - render/bind/unbind are only called on load, after that it's setcontext
 *     and update. update is
 *  - identical to render by default, but you can override it. the update
 *     lifecycle is only triggered if
 *  - another tool changes the splinter, so if your tool changes a context
 *     value, you update your view there.
 */

(function () {
  "use strict";

  var formEditorTool = new FormEditorTool();
  formEditorTool.name = "submission-form-editor";
  formEditorTool.filterFields = "submission";
  Sparkle.PageBuilder.Tool(formEditorTool);
})();
